import React, { useEffect, useState } from "react";
import {
  Form,
  Row,
  Col,
  Space,
  DatePicker,
  Input,
  Button,
  Spin,
  message,
} from "antd";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { InputFields } from "components/common";
import { employeeService } from "api";

import { setEmployee } from "redux/reducer/employee";
import Notification from "../../../../../../components/common/notification/notification";
import dayjs from "dayjs";
import { dataFields as inputFieldsInit } from "./paymentRequest.config";
import { RangePickerProps } from "antd/es/date-picker";
import { ExcelSVG } from 'assets';
import { generateFileName } from "helper/common";
import axiosClient from "api/axiosClient";
const PayMentRequest = (props) => {
  const { data, closeModal, type, getListApi,params, setCurrentPage } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [code, setCode] = useState(null);
  const employeesStore = useAppSelector(
    (state) => state.employeesReducer.employee
  );
  const handleExportExcelPayMent = async () => {
    const url = "hanhchinhnhansu/payment-request";
    const baseName = "Payment-Request";
    const fileExtension = "xlsx";
    const fileName = generateFileName(baseName, fileExtension);
    try {
      const paramss = {
        ...params,
        ...form.getFieldsValue(),
      };
      const response = await axiosClient.post(url, paramss, {
        responseType: "blob",
      });
      const blob = await response.data;
      // Create a blob URL
      const blobUrl = window.URL.createObjectURL(blob);
      // Create a link element for downloading
      const downloadLink = document.createElement("a");
      downloadLink.href = blobUrl;
      downloadLink.download = fileName;
      // Append the link to the document, trigger click, and remove the link
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      closeModal();
    } catch (error) {
      // Handle the error, e.g., show an error message to the user
      Notification("error", "Error exporting Excel");
    }
  };
  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={inputFieldsInit}></InputFields>
            </Row>
            <Row justify="end">
              <Col>
                <Space>
                  <Button onClick={closeModal} style={{ backgroundColor: "red", borderColor: "red" , color: "white"  }}>Hủy bỏ</Button>
                  <Button type="primary" onClick={handleExportExcelPayMent}
                  icon={<ExcelSVG />}>
                  Xuất Payment
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default PayMentRequest;
